import styled from "styled-components";
import { Spinner } from "react-bootstrap";

function hasFilledBackground(ButtonInlineStyle) {
  const bg = ButtonInlineStyle?.backgroundColor;
  if (!bg || bg === "transparent") return false;
  return true;
}

export const ButtonComp = ({
  btnText,
  divClassName,
  btnClassName,
  containerClassName,
  onClick,
  type,
  BorderColor,
  BorderWidth,
  ButtonInlineStyle,
  loading,
  disabled,
  ...props
}) => {
  const filled = hasFilledBackground(ButtonInlineStyle);
  // Only force transparent for explicit outline buttons (BorderColor set).
  // Otherwise leave background to btnClassName / inline styles.
  const outline = Boolean(BorderColor) && !filled;

  return (
    <ButtonStyle
      className={`w-full ${containerClassName || ""}`}
      BorderColor={BorderColor}
      BorderWidth={BorderColor ? "2px" : BorderWidth}
      $filled={filled}
      $outline={outline}
    >
      <div className={`${divClassName || ""}`}>
        <button
          className={`${btnClassName || ""}`}
          style={{ ...ButtonInlineStyle }}
          onClick={onClick}
          {...props}
          type={type}
          disabled={loading || disabled}
        >
          {loading ? (
            <div className="d-flex align-items-center justify-content-center gap-2">
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span>Processing...</span>
            </div>
          ) : (
            btnText
          )}
        </button>
      </div>
    </ButtonStyle>
  );
};
const ButtonStyle = styled.div`
  button {
    ${(props) =>
      props.$filled
        ? "background: unset;"
        : props.$outline
        ? "background: transparent;"
        : ""}
    ${(props) =>
      props.BorderColor
        ? `
    border-color: ${props.BorderColor} !important;
    border-width: ${props.BorderWidth || "2px"} !important;
    `
        : ""}
  }
`;
